var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.75 21c0 .4142-.33579.75-.75.75h-6c-.41421 0-.75-.3358-.75-.75v-6c0-.4142.33579-.75.75-.75s.75.3358.75.75v4.1893l6.7197-6.7196c.2929-.2929.7677-.2929 1.0606 0s.2929.7677 0 1.0606l-6.71964 6.7197h4.18934c.41421 0 .75.3358.75.75z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.00055 12.9836c.3011-.1495.64046-.2336.99945-.2336 1.24264 0 2.25 1.0074 2.25 2.25v.568l4.15901-4.159c.87869-.8787 2.30329-.8787 3.18199 0s.8787 2.3033 0 3.182l-4.15902 4.159h.56802c1.2426 0 2.25 1.0074 2.25 2.25 0 .359-.0841.6983-.2336.9995.316.0005.6437.0005.9836.0005 4.714 0 7.0711 0 8.5355-1.4645 1.4645-1.4644 1.4645-3.8215 1.4645-8.5355 0-4.71405 0-7.07107-1.4645-8.53553-1.4644-1.46447-3.8215-1.46447-8.5355-1.46447-4.71405 0-7.07107 0-8.53553 1.46447-1.46447 1.46446-1.46447 3.82148-1.46447 8.53553 0 .3399 0 .6676.00055.9836z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseLeaderboard);
export default __webpack_public_path__ + "static/media/collapse_leaderboard.eeb6ec1bdad6b6b3837f47e39b505da7.svg";
export { ForwardRef as ReactComponent };